import SendFiles2DIcon from 'src/assets/svg/send-files-2d-icon';
import { generateExchangeTaxpayerAPIURL } from '../common/common-api';
import styles from './send-files.module.scss';
import { DeviceType } from 'src/hooks/useDeviceType';

interface ISendFilesProps {
	deviceType: string;
}

const SendFiles: React.FC<ISendFilesProps> = ({ deviceType }) => {
	const goToSSEDropOffPortal = () => {
		generateExchangeTaxpayerAPIURL();
	};

	return (
		<div className={styles.sendFilesModule}>
			<div className={styles.headerSendFiles}>Send Files</div>
			<div className={styles.body}>
				{deviceType === DeviceType.Desktop ? (
					<div
						className={styles.bodyTitleContainer}
						onClick={goToSSEDropOffPortal}>
						Send Files to Tax Professional or Tax Preparer.
					</div>
				) : (
					<span
						className={styles.sendFilesIcon}
						onClick={goToSSEDropOffPortal}
						title='Send Files'>
						<SendFiles2DIcon color='#0973ba' />
					</span>
				)}
			</div>
		</div>
	);
};

export default SendFiles;
